import { memo } from 'react';
import { Box, Skeleton } from '@mui/material';
import { IEmployeeSearchResProperties } from '@legacy/apis/resourcePlannerAPI';
import { FeatureControl } from '@legacy/components/utils/FeatureControl';
import { CompetenceList } from '../CompetenceList';
import { EmployeeCard } from '../EmployeeCard';
import styles from './EmployeeWithCompetence.module.scss';

interface IEmployeeWithCompetence {
  resource: IEmployeeSearchResProperties;
  onClick?: (r: IEmployeeSearchResProperties) => void;
  query?: string;
  showDepartmentFilter?: boolean;
  showLegalEntityFilter?: boolean;
}

export const EmployeeWithCompetence = memo(
  ({
    onClick,
    query,
    resource,
    showDepartmentFilter,
    showLegalEntityFilter,
  }: IEmployeeWithCompetence) => (
    <Box
      className={styles.gridBox}
      data-automation-id="EmployeeWithCompetence"
      onClick={() => onClick?.(resource)}
      role={onClick ? 'button' : undefined}
    >
      <Box className={styles.box}>
        <EmployeeCard
          capacity={resource.capacity}
          department={resource.department}
          legalEntity={resource.legalEntity}
          fullName={resource.fullName}
          initials={resource.initials}
          position={resource.position}
          query={query}
          showDepartmentFilter={showDepartmentFilter}
          showLegalEntityFilter={showLegalEntityFilter}
          userId={resource.userId}
        />
      </Box>
      <FeatureControl indexControlName="Competences">
        <Box className={styles.box}>
          <CompetenceList
            competenceList={resource.competences ?? []}
            query={query}
          />
        </Box>
      </FeatureControl>
    </Box>
  ),
);

export const EmployeeWithCompetenceSkeleton = () => (
  <Box className={styles.gridBox}>
    <Box className={styles.box}>
      <Skeleton variant="rectangular" width="100%" height={60} />
    </Box>
    <FeatureControl indexControlName="Competences">
      <Box className={styles.box}>
        <Skeleton variant="rectangular" width="100%" height={60} />
      </Box>
    </FeatureControl>
  </Box>
);
